import { storeDefault } from '@/pages/order/hooks/useDeliver'

export default {
  state: {
    delieverSwitch: 1,
    newOrderInfo: '',
    useIntegral: false,
    /** @from subtotal */
    storeInfo: storeDefault(),
    agentStoreInfo: null,
    choseCoupons: [],
    choseIntegral: false,
    sumIntegralAmount: -1
  },
  mutations: {
    SET_DELIVERSWITCH(state, val) {
      state.delieverSwitch = val
    },
    SET_NEW_ORDER_INFO(state, val) {
      state.newOrderInfo = val
    },
    SET_USE_INTERGRAL(state, val) {
      state.useIntegral = val
    },
    SET_STORE_INFO(state, val) {
      state.storeInfo = val
    },
    SET_AGENT_STORE_INFO(state, val) {
      state.agentStoreInfo = val
    },
    SET_CHOSE_COUPONS(state, val) {
      state.choseCoupons = val
    },
    SET_IF_CHOOSE_INTEGRAL(state, val) {
      state.choseIntegral = val
    },
    SET_SUM_INTEGRAL_AMOUNT(state, val) {
      state.sumIntegralAmount = val
    }
  },
}
